import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Importar páginas públicas
import HomePage from './pages/public/HomePage';
import CategoiresPage from './pages/public/CategoriesPage';
import TutorialsUnified from './pages/public/TutorialsUnified';
import CategoryTutorialsPage from './pages/public/CategoryTutorialsPage';
import TreinamentosPage from './pages/public/TreinamentosPage';
import GeradorSenha from './pages/public/dashboard/GeradorSenha';
import PrecoCombustivel from './pages/public/dashboard/PrecoCombustivel';
import CadastrosPage from './pages/public/CadastrosPage';
import RetaguardaTutorialsPage from './pages/public/RetaguardaTutorialsPage';
import ConvenienciaTutorialsPage from './pages/public/ConvenienciaTutorialsPage';
import DashboardTutorialsPage from './pages/public/DashboardTutorialsPage';
import PistaTutorialsPage from './pages/public/PistaTutorialsPage';
import VideoTutorialsPage from './pages/public/VideoTutorialsPage';
import VideoTutorialDetailPage from './pages/public/VideoTutorialDetailPage';
import TutorialViewPage from './pages/public/TutorialViewPage';
import NovaPagina from './pages/public/NovaPagina';
import IAPage from './pages/public/IAPage';
import ServicosPage from './pages/public/ServicosPage';
import BlogPage from './pages/public/BlogPage';
import BlogPostDetailPage from './pages/public/BlogPostDetailPage';
import BlogPostsPage from './pages/public/BlogPostsPage';
import BlogPostPage from './pages/public/BlogPostPage';
import AppsPage from './pages/public/AppsPage';
import VerPage from './pages/public/VerPage';
import ApresentacaoSistemasPage from './pages/public/ApresentacaoSistemasPage';
import ERPPage from './pages/public/ERPPage';
import SobreNos from './pages/public/SobreNos';
import ConciliacaoPage from './pages/public/ConciliacaoPage';
import FullcheckPage from './pages/public/FullcheckPage';
import FidelidadePage from './pages/public/FidelidadePage';
import SolucoesPage from './pages/public/SolucoesPage';
import ContatoPage from './pages/public/ContatoPage';
import LmsDemoPage from './pages/public/LmsDemoPage';
import ProductsPage from './pages/public/ProductsPage';
import ProductDetailPage from './pages/public/ProductDetailPage';

// Importar páginas premium Lukos
import LukosAIPage from './pages/public/LukosAIPage';
import LukosPDVPage from './pages/public/LukosPDVPage';
import LukosConciliacaoPage from './pages/public/LukosConciliacaoPage';
import LukosDashboardPage from './pages/public/LukosDashboardPage';
import LukosFidelidadePage from './pages/public/LukosFidelidadePage';
import LukosPayPage from './pages/public/LukosPayPage';
import FeatureDetailPage from './pages/public/FeatureDetailPage';

// Importar páginas administrativas

export function AppRoutes() {
  return (
    <Routes>
      {/* Rotas públicas principais */}
      <Route path="/" element={<BlogPage />} />
      <Route path="/blog" element={<BlogPostsPage />} />
      <Route path="/sobre-nos" element={<SobreNos />} />

      {/* Rotas dos Tutoriais Lukos */}
      <Route path="/tutoriais" element={<TutorialsUnified />} />
      <Route path="/tutoriais/:slug" element={<TutorialViewPage />} />
      <Route path="/tutoriais/treinamentos" element={<TreinamentosPage />} />
      <Route path="/video-tutoriais" element={<VideoTutorialsPage />} />
      <Route path="/video-tutorial/:id" element={<VideoTutorialDetailPage />} />
      <Route path="/categoria/:category" element={<CategoryTutorialsPage />} />

      {/* Rotas Hierárquicas */}
      <Route path="/cadastros" element={<CadastrosPage />} />

      {/* Rotas Dashboard */}
      <Route path="/pages/GeradorSenha" element={<GeradorSenha />} />
      <Route path="/pages/PrecoCombustivel" element={<PrecoCombustivel />} />

      {/* Rotas de Tutoriais por Seção - Redirecionadas para filtros de URL */}
      <Route path="/retaguarda-tutoriais" element={<Navigate to="/tutoriais?categoria=retaguarda" replace />} />
      <Route path="/conveniencia-tutoriais" element={<Navigate to="/tutoriais?categoria=conveniencia" replace />} />
      <Route path="/dashboard-tutoriais" element={<Navigate to="/tutoriais?categoria=dashboard" replace />} />
      <Route path="/pista-tutoriais" element={<Navigate to="/tutoriais?categoria=pista" replace />} />

      {/* Nova Página */}
      <Route path="/nova-pagina" element={<NovaPagina />} />
      <Route path="/conciliacao" element={<ConciliacaoPage />} />
      <Route path="/fullcheck" element={<FullcheckPage />} />
      <Route path="/fidelidade" element={<FidelidadePage />} />
      <Route path="/lms-demo" element={<LmsDemoPage />} />

      {/* Página de IA */}
      <Route path="/ia" element={<IAPage />} />

      {/* Páginas Premium Lukos */}
      <Route path="/lukos-ai" element={<LukosAIPage />} />
      <Route path="/lukos-pdv" element={<LukosPDVPage />} />
      <Route path="/lukos-conciliacao" element={<LukosConciliacaoPage />} />
      <Route path="/lukos-dashboard" element={<LukosDashboardPage />} />
      <Route path="/lukos-fidelidade" element={<LukosFidelidadePage />} />
      <Route path="/lukos-pay" element={<LukosPayPage />} />
      <Route path="/funcionalidades/:slug" element={<FeatureDetailPage />} />

      {/* Página de Soluções Interativas */}
      <Route path="/solucoes" element={<SolucoesPage />} />

      {/* Página de Contato */}
      <Route path="/contato" element={<ContatoPage />} />

      {/* Página de Serviços */}
      <Route path="/servicos" element={<ServicosPage />} />

      {/* Página do Blog */}
      <Route path="/blog/:id" element={<BlogPostDetailPage />} />
      <Route path="/blog-posts" element={<BlogPostsPage />} />
      <Route path="/artigo/:id" element={<BlogPostPage />} />

      {/* Página de Aplicativos */}
      <Route path="/apps" element={<AppsPage />} />

      {/* Página de Visualização */}
      <Route path="/ver" element={<VerPage />} />

      {/* Página de Apresentação dos Sistemas */}
      <Route path="/apresentacao-sistemas" element={<ApresentacaoSistemasPage />} />
      <Route path="/sistemas" element={<ApresentacaoSistemasPage />} />
      <Route path="/erp" element={<ERPPage />} />
      <Route path="/produtos" element={<ProductsPage />} />
      <Route path="/produto/:id" element={<ProductDetailPage />} />

      {/* Rotas administrativas */}

      {/* Rotas de autenticação */}

      {/* Rotas protegidas */}

      {/* Editor Visual */}
    </Routes>
  );
}
